import type { MediaState, MutationClass } from '../../../models'

export class SetViewportWidthMutation implements MutationClass {
  static execute(this: void, state: MediaState, viewportWidth: number): void {
    state.viewportWidth = viewportWidth
  }
}
